import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";
import { Message } from '../../models/message';
import { MessagingService } from '../../services/messaging.service';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent implements OnInit {

  messages: Observable<Message[]>;
  msgLoading: boolean;
  msgMax: number = 3;
  msgPage: number = 1;
  msgTotal: number = 0;
  userId: string;
  jobId: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public message: MessagingService) { }

  ngOnInit() {
    this.userId = this.data.userId;
    this.jobId = this.data.jobId;
    this.msgMax = this.data.msgMax;
    this.fetchMessages(1);
  }

  fetchMessages(page) {
    this.msgLoading = true;
    this.messages = this.message.getMessage(this.userId, undefined, page, this.msgMax)
      .do(res => {
        this.msgTotal = res.pagination.total;
        this.msgPage = page;
        this.msgLoading = false;
      })
      .map(res => res.messages);
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message-dialog/message-dialog.component.ts